import React, { useRef, Fragment, useState, memo } from "react";
import { compose } from "redux";
import classNames from "classnames";

import draggable from "fantastic/components/hoc/draggable";
import droppable from "fantastic/components/hoc/droppable";
import selectable from "fantastic/components/hoc/selectable";
import styles from "fantastic/components/hoc/styles";
import connectActions from "fantastic/lib/connectActions";
import actions from "fantastic/actions";

import Column from "./Column";
import SectionColumnResizer from "fantastic/components/common/SectionColumnResizer";
import utils from "fantastic/lib/utils";
import sectionPadding from "fantastic/lib/sectionPadding";
const { px, proc, url } = utils;

const Section = ({
  id,
  contents,
  full_width,
  style,
  meta: { selected },
  update,
  border_radius,
  border_color,
  border_width,
  border_style,
  css_padding_left,
  css_padding_right,
  css_padding_top,
  css_padding_bottom
}) => {
  const [resizing, setResizing] = useState(null);
  const [rowIndex, setRowIndex] = useState(null);
  const [sizes, setSizes] = useState(null);

  const checkItems = ({ items }) => items && items.length > 0;
  const allEmpty = !contents.some(checkItems);
  const isEmpty = column => !checkItems(column);

  const table = classNames("fantastic-section", {
    row: full_width,
    container: !full_width,
    "fantastic-section--resizing": !!resizing,
    "fantastic-section--all-empty": allEmpty
  });
  const row = classNames({
    row: !full_width,
    container: full_width
  });

  const columnClasses = ({ column }) => classNames("columns", column);
  const ItemsWrapperClasses = column =>
    classNames({
      "ftc-column--empty": isEmpty(column)
    });

  const wrapperClasses = ({ items, meta: { firstChild, lastChild } }) =>
    classNames("wrapper", {
      first: firstChild,
      last: lastChild,
      empty: !items || items.length === 0
    });

  const handleResizeStop = () => {
    update(resizing.id, sizes);
    setResizing(null);
  };
  const wrapperPadding = (column) =>
    sectionPadding(column, { css_padding_left, css_padding_right, css_padding_top, css_padding_bottom });

  return (
    <table className={table} style={full_width ? style : {}}>
      <tbody>
        <tr>
          <td>
            <table className={row} style={full_width ? {} : style }>
              <tbody>
                <tr>
                  {contents &&
                    contents.map(column => (
                      <Fragment key={column.id}>
                        <td className={wrapperClasses(column)}>
                          <table className={columnClasses(column)}>
                            <tbody>
                              <tr>
                                <td className={ItemsWrapperClasses(column)} style={wrapperPadding(column)}>
                                  <Column {...column} />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        {selected && !column.meta.lastChild && (
                          <SectionColumnResizer
                            className="fantastic-column__resizer"
                            onResizeStart={() => setResizing(column)}
                            onResizeStop={handleResizeStop}
                            onResize={(prev, next) => setSizes([prev, next])}
                          />
                        )}
                      </Fragment>
                    ))}
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default compose(
  selectable(),
  droppable("SECTION"),
  draggable("SECTION"),
  styles("background", "border-section"),
  connectActions({
    update: actions.updateSectionColumns
  })
)(Section);
